import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import { BoxContainer, SrcInfoContainer } from '@nile/banyan/src/Utils/style';
import {
  getTranslatedText,
  AccessControl,
  BackgroundIcon
} from '@nile/components';
import { DeleteModal } from '@nile/components/src';
import RenderFieldTypeIcon from '@nile/banyan/src/Pebbles/field-type-icon/index';
import {
  Button,
  ButtonGroup,
  Heading,
  ResourceItem,
  ResourceList
} from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { CascadeCard } from '../../../../components/src/Utils/style';

const BoxContainerWrapper = styled(CascadeCard)`
  .cascadeContainer:first-child {
    background: var(--sops-white-transparent-bg) !important;
    border-radius: 0;
    border-right: 1px solid #0000001a;
    width: 30%;
    overflow: hidden;
  }
  .cascadeContainer:last-child {
    border-radius: 0px 12px 12px 0px;
    padding: 30px 20px 0 35px;
  }
  .sticky-search {
    padding-top: 30px;
    .Polaris-TextField__Input:focus {
      border: 1px solid #dedede;
    }
  }
  .list-no-pad .list-item {
    height: 44px;
    padding-top: 12px;
    padding-left: 40px;
    padding-bottom: 12px;
  }
  .list-item-label {
    font-weight: 500;
  }
  .bshadow {
    height: 100%;
  }
`;

const InfoContainer = styled(SrcInfoContainer)`
  margin: 0 !important;
  .Polaris-Subheading {
    margin-top: 8px !important;
  }
`;

class CustomFieldsCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      value: [],
      selectedField: null,
      selectedItems: props.data.length > 0 ? [props.data[0].id] : [],
      fields: props.data ? props.data : []
    };
  }

  renderSubItem = (item) => {
    this.setState({ selectedField: item });
  };

  componentDidMount() {
    if (this.props.data.length > 0) {
      this.renderSubItem(this.props.data[0]);
    }
  }

  deleteCustomField = (id) => {
    this.props.deleteCustomField({
      variables: { id }
    });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
    }
  };

  handleFieldChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const { intl, roleToCheck } = this.props;
    const { selectedField, selectedItems } = this.state;
    const { fields } = this.state;
    const processedAllItems = processData(fields, 'id');
    return (
      <BoxContainerWrapper>
        <BoxContainer className="fx white-transparent-bg full-height">
          <div className="fx cascadeContainer h-auto">
            <div className="full-width fx col">
              <div className="sticky-search">
                <AutoComplete
                  options={processedAllItems}
                  handleChange={this.handleFieldChange}
                  showAllOnEmpty={false}
                />
              </div>
              <div className="cascade-list f11">
                <ResourceList
                  items={fields}
                  selectedItems={selectedItems}
                  onSelectionChange={this.setSelectedItems}
                  renderItem={(item) => {
                    const { id, label, fieldType } = item;
                    return (
                      <ResourceItem
                        id={id}
                        accessibilityLabel={`View details for ${label}`}
                        customClassName="list-no-pad"
                        gutter="md"
                      >
                        <div
                          className="fw fx actr list-item"
                          onClick={this.renderSubItem.bind(this, item)}
                        >
                          <span className="mr10 fx actr">
                            <RenderFieldTypeIcon
                              type={fieldType}
                              color={
                                selectedItems?.includes(id)
                                  ? '#ffffff'
                                  : '#000000'
                              }
                            />
                          </span>
                          <span className="list-item-label">{label}</span>
                        </div>
                      </ResourceItem>
                    );
                  }}
                />
              </div>
            </div>
          </div>
          {selectedField && (
            <div className="fx cascadeContainer h-auto">
              <div className="full-width">
                <InfoContainer>
                  <div className="fx2">
                    <Heading element="h1">{selectedField.label}</Heading>
                    <p className="desc mt-10"> {selectedField.description} </p>
                  </div>
                  <div className="fx jend self-start Custom-Fields-Actions">
                    <ButtonGroup>
                      <AccessControl
                        roleToCheck={`${roleToCheck || 'customFields'}.delete`}
                        render={
                          <DeleteModal
                            description={getTranslatedText(
                              intl,
                              'admin.CustomFields.delete.confirm'
                            )}
                            handleDeleteConfirmation={() =>
                              this.deleteCustomField(selectedField.id)
                            }
                            title={getTranslatedText(
                              intl,
                              'admin.CustomFields.delete.text'
                            )}
                          />
                        }
                      />
                      <AccessControl
                        roleToCheck={`${roleToCheck || 'customFields'}.edit`}
                        render={
                          <Button
                            secondary
                            icon={
                              <div className="fx center">
                                <SVGIcon name="Edit" />
                              </div>
                            }
                            onClick={() =>
                              this.props.editCustomField(selectedField.id)
                            }
                          />
                        }
                      />
                    </ButtonGroup>
                  </div>
                </InfoContainer>
                <div className="fx mt-20 col">
                  <div className="mt-15 mb-20">
                    <Heading element="h3">
                      <FormattedMessage id="admin.CustomFields.create.fieldtype" />
                    </Heading>
                    <div className="mt-10">{selectedField.fieldType}</div>
                  </div>
                  {selectedField.options && (
                    <div className="mt-15 mb-20">
                      <Heading element="h3">
                        <FormattedMessage id="admin.CustomFields.create.choices" />
                      </Heading>
                      {selectedField.options.map((el) => {
                        return <div className="mt-10">{el}</div>;
                      })}
                    </div>
                  )}
                  {!this.props?.hidePermissions && (
                    <div className="mt-15 mb-20">
                      <Heading element="h3">
                        <FormattedMessage id="admin.CustomFields.create.permissions" />
                      </Heading>
                      <div className="mt-10">
                        {selectedField.showToClient
                          ? 'Visible to clients'
                          : 'Not visible to clients'}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </BoxContainer>
      </BoxContainerWrapper>
    );
  }
}

export default injectIntl(CustomFieldsCascade);
